<template>
    <!-- Page content -->
<div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

        <!-- Content area -->
        <div class="content d-flex justify-content-center align-items-center">

            <!-- Password recovery form -->
            <form class="login-form" @submit.prevent="saveChangePassword()" ref="changePassword">
                <div class="card mb-0">
                    <div class="card-body">
                        <div class="text-center mb-3">
                            <i class="icon-key icon-2x text-warning border-warning border-3 rounded-round p-3 mb-3 mt-1"></i>
                            <h5 class="mb-0">Change password</h5>
                            <!-- <span class="d-block text-muted">We'll send you instructions in email</span> -->
                        </div>

                        <div class="form-group form-group-feedback form-group-feedback-right">
                            <input type="password" class="form-control" placeholder="New password" v-model="newPassword">
                            <div class="form-control-feedback">
                                <!-- <i class="icon-mail5 text-muted"></i> -->
                            </div>
                        </div>

                        <button type="submit" class="btn bg-blue btn-block" :disabled="!newPassword">Save</button>
                    </div>
                </div>
            </form>
            <!-- /password recovery form -->

        </div>
        <!-- /content area -->

      <!-- Footer -->
      <!-- <div class="navbar navbar-expand-lg navbar-light">

        <div class="navbar-collapse collapse" id="navbar-footer">
          <span class="navbar-text">
            &copy; 2015 - 2018. InsightEra Co., Ltd
          </span>
        </div>
      </div> -->
      <!-- /footer -->

    </div>
    <!-- /main content -->

</div>
<!-- /page content -->
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Swal from 'sweetalert2'
export default {
  data () {
    return {
      newPassword: null
    }
  },
  computed: {
    ...mapGetters({ userId: 'userId' })
  },
  methods: {
    ...mapActions({ changePassword: 'changePassword', resetState: 'resetState' }),
    async saveChangePassword () {
      if (this.newPassword) {
        try {
          let response = await this.changePassword({ reset_password: this.newPassword })
          if (response) {
            Swal.fire({
              title: 'Done',
              text: 'Password has been updated, please login again',
              heightAuto: false
            }).then(() => {
              this.$refs.changePassword.reset()
              this.resetState()
              setTimeout(() => {
                this.$router.push({ name: 'login' })
              }, 0)
            })
          } else {
            Swal.fire({
              title: 'Error',
              text: 'Something went wrong. Please try again',
              heightAuto: false
            })
          }
        } catch (error) {
          Swal.fire({
            title: 'Error',
            text: 'Something went wrong. Please try again',
            heightAuto: false
          })
        }
      }
    }
  }
}
</script>
